export class ConfiguracoesVidaGlobal {

    funcionario: number
    socio: number
    capitalFuncionario: number
    capitalSocio: number
    isAppMorteAcidental: boolean
    isAppInvalidez: boolean
    isInvalidezDoenca: boolean
    funeral: any

    constructor() {
        this.funcionario = null;
        this.socio = null;
        this.capitalFuncionario = null;
        this.capitalSocio = null;
        this.isAppMorteAcidental = null;
        this.isAppInvalidez = null;
        this.isInvalidezDoenca = null;
        this.funeral = { tipo: 0, valor: null };
    }
}